import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { filter, take, switchMap } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { Chain } from 'src/app/classes/async-chain';
import { POSITIONS } from 'src/app/constants/positions';
import { UserFacade } from 'src/app/services/facades/user/user.facade';
import { State } from 'src/app/state/interfaces';
import { logoutSuccess } from 'src/app/state/actions/auth/auth.actions';
import { AuthEffects } from 'src/app/state/effects/auth.effects';

import { AuthFacade } from './facades/auth/auth.facade';
import { FirebaseAuthService } from './firebase-auth.service';
import { AppService } from './app.service';
import branch from 'branch-sdk';

@Injectable({ providedIn: 'root' })
export class FlowService {
  private _init = new Chain({ debug: !this.app.isProduction, id: 'init' })
    .add('async', {
      token: () => this.firebaseAuth.authReady(),
    })
    .add('sync', '', ({ token }) =>
      this.authFacade.setToken(token),
    )
    .add('sync', 'profile', ({ token }) => {
      if(token){
        return this.userFacade.getProfile()
      }else{
        return null
      }
    })
    .add('sync', '', ({ profile }) => {
      if(profile['user'] && profile['user'].position != 'admin'){
        this._logout.execute();
      }
    })


  private _login = new Chain({ debug: !this.app.isProduction, id: 'login' })
    .add('sync', '', () => this.userFacade.getProfile())
    .add('sync', 'user', () => this.userFacade.state.user$.pipe(take(1)))
    .add('sync', 'position', ({ user }) => user.position)
    .add('sync', '', ({ position }) => {
      if (POSITIONS.ADMIN.includes(position)) {
        this.router.navigateByUrl('admin')
      }else{
        this._logout.execute();
      }

    });


  private _logout = new Chain({ debug: !this.app.isProduction, id: 'logout' })
    .add('async', {
      token: () => localStorage.removeItem('admin-token'),
    })
    .add('sync', '', () => this.store.dispatch(logoutSuccess()))
    .add('sync', '', () => this.router.navigateByUrl('/'));

  constructor(
    private app: AppService,
    private store: Store<State>,
    private authEffects: AuthEffects,
    private authFacade: AuthFacade,
    private userFacade: UserFacade,
    private router: Router,
    private firebaseAuth: FirebaseAuthService,
  ) {
    app.expose('services', 'flow', this);
  }

  register() {
    this._init.execute();
    this._login.startOn(this.authEffects.login$);
    this._logout.startOn(this.authEffects.logout$);

    // Sync Firebase token changes (including proactive refresh) into NgRx store.
    // Wait for authReady$ to avoid syncing before Firebase has had a chance to
    // refresh an expired token.
    this.firebaseAuth.authReady$.pipe(
      filter(ready => ready),
      take(1),
      switchMap(() => this.firebaseAuth.token$)
    ).subscribe((token) => {
      if (token) {
        this.authFacade.setToken(token);
      }
    });
    this.userFacade.effects.getProfile$.subscribe((p)=>{
      // if(p['user'] && p['user'].position != 'admin'){
      //   this.managerFlowService.register();
      // }
    });
    branch.init(environment.branchKey, function(err, data) {
      // console.log('branch.init', err, data);
    });
  }
}
